import { fetchUtils } from '../utils/fetchUtils';

export const uploadResume = (data) => fetchUtils.post('/api/resume/upload', data);
export const getAllResumes = (params) => fetchUtils.get('/api/resume', params);
export const getResumeById = (id) => fetchUtils.get(`/api/resume/${id}`);
export const deleteResume = () => fetchUtils.delete(`/api/resume`);
